import PromoPanel from './PromoPanel';
export * from './PromoPanel';
export default PromoPanel;
